import api from 'common/api';
import lambda from 'common/lambda';

export const getGenerallistAPI = (params: any) => api.get('/common/generallist', params);

export const getGeneraDropListOfficeAPI = (params: any) => api.get('/common/general-droplist-office', params);

export const getPortlistAPI = (params: any) => api.get('/common/portlist', params);

export const getStatuslistAPI = (params: any) => api.get('/common/statuslist', params);

export const getEntityInfoAPI = (params: any) => api.get('/common/entity-infor', params);

export const getUserInfoAPI = () => api.get('/auth/me');

export const getUserGrpListAPI = (params: any) => api.get('/common/user-grp', params);

export const getSignedUrlAPI = (params: any) => api.get('/common/signedUrl', params);

export const compressFileDownloadAPI = (params: any) => lambda.post('/compressFileDownload', params);
